import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue"


import sooiPo from "@/assets/calculators/room-mapping/sooi_po.svg";
import taiShoo from "@/assets/calculators/room-mapping/tai_shoo.svg";
import yearSha from "@/assets/calculators/room-mapping/year_sha.svg";
import monthSha from "@/assets/calculators/room-mapping/month_sha.svg";
import taiYan from "@/assets/calculators/room-mapping/tai_yan.svg";
import taiYin from "@/assets/calculators/room-mapping/tai_yin.svg";
import nobleHappy from "@/assets/calculators/room-mapping/noble_happy.svg";
import nobleDragon from "@/assets/calculators/room-mapping/noble_dragon.svg";
import DiagramImageComponent from "@/views/Calculators/ApartmentPlan/components/stage/DiagramImageComponent.vue";
import { AptDateParamsResponse, IImageConfig } from "@/types/apartmentPlan";
import { ToggleKey } from "@/constants/apartmentPlan";


export default /*@__PURE__*/_defineComponent({
  __name: 'DiagramImageLayer',
  props: {
    diagramConfig: {},
    diagramDateParams: {},
    toggles: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_image = _resolveComponent("v-image")!
  const _component_v_group = _resolveComponent("v-group")!

  return (_openBlock(), _createBlock(_component_v_group, null, {
    default: _withCtx(() => [
      (__props.diagramConfig && __props.toggles['sectors-diagram'])
        ? (_openBlock(), _createBlock(_component_v_image, {
            key: 0,
            config: __props.diagramConfig
          }, null, 8, ["config"]))
        : _createCommentVNode("", true),
      (__props.diagramDateParams && __props.toggles['sui-po'])
        ? (_openBlock(), _createBlock(DiagramImageComponent, {
            key: 1,
            diagramComponent: _unref(sooiPo),
            diagramConfig: __props.diagramConfig,
            rotationOffset: __props.diagramDateParams.sui_po
          }, null, 8, ["diagramComponent", "diagramConfig", "rotationOffset"]))
        : _createCommentVNode("", true),
      (__props.diagramDateParams && __props.toggles['tai-shoo'])
        ? (_openBlock(), _createBlock(DiagramImageComponent, {
            key: 2,
            diagramComponent: _unref(taiShoo),
            diagramConfig: __props.diagramConfig,
            rotationOffset: __props.diagramDateParams.tai_shoo
          }, null, 8, ["diagramComponent", "diagramConfig", "rotationOffset"]))
        : _createCommentVNode("", true),
      (__props.diagramDateParams && __props.toggles['year-sha'])
        ? (_openBlock(), _createBlock(DiagramImageComponent, {
            key: 3,
            diagramComponent: _unref(yearSha),
            diagramConfig: __props.diagramConfig,
            rotationOffset: __props.diagramDateParams.year_sha
          }, null, 8, ["diagramComponent", "diagramConfig", "rotationOffset"]))
        : _createCommentVNode("", true),
      (
        __props.diagramDateParams && __props.diagramDateParams.month_sha && __props.toggles['month-sha']
      )
        ? (_openBlock(), _createBlock(DiagramImageComponent, {
            key: 4,
            diagramComponent: _unref(monthSha),
            diagramConfig: __props.diagramConfig,
            rotationOffset: __props.diagramDateParams.month_sha
          }, null, 8, ["diagramComponent", "diagramConfig", "rotationOffset"]))
        : _createCommentVNode("", true),
      (__props.diagramDateParams && __props.toggles['noble-stars'])
        ? (_openBlock(), _createBlock(DiagramImageComponent, {
            key: 5,
            diagramComponent: _unref(taiYan),
            diagramConfig: __props.diagramConfig,
            rotationOffset: __props.diagramDateParams.tai_yan
          }, null, 8, ["diagramComponent", "diagramConfig", "rotationOffset"]))
        : _createCommentVNode("", true),
      (__props.diagramDateParams && __props.toggles['noble-stars'])
        ? (_openBlock(), _createBlock(DiagramImageComponent, {
            key: 6,
            diagramComponent: _unref(taiYin),
            diagramConfig: __props.diagramConfig,
            rotationOffset: __props.diagramDateParams.tai_yin
          }, null, 8, ["diagramComponent", "diagramConfig", "rotationOffset"]))
        : _createCommentVNode("", true),
      (__props.diagramDateParams && __props.toggles['noble-stars'])
        ? (_openBlock(), _createBlock(DiagramImageComponent, {
            key: 7,
            diagramComponent: _unref(nobleDragon),
            diagramConfig: __props.diagramConfig,
            rotationOffset: __props.diagramDateParams.noble_dragon
          }, null, 8, ["diagramComponent", "diagramConfig", "rotationOffset"]))
        : _createCommentVNode("", true),
      (__props.diagramDateParams && __props.toggles['noble-stars'])
        ? (_openBlock(), _createBlock(DiagramImageComponent, {
            key: 8,
            diagramComponent: _unref(nobleHappy),
            diagramConfig: __props.diagramConfig,
            rotationOffset: __props.diagramDateParams.noble_happy
          }, null, 8, ["diagramComponent", "diagramConfig", "rotationOffset"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})